<template>
  <ul v-if="notifications" class="fixed z-50 top-24 right-4 w-full max-w-sm">
    <li v-for="(notification, key) in notifications" :key="key" class="mb-2">
      <AppNotification
        :title="notification.title"
        :message="notification.message"
        :type="notification.type"
        @dismiss="notificationStore.dismiss(notification.id)"
      />
    </li>
  </ul>
</template>

<script>
import notificationStore from '@/store/modules/notifications';
import AppNotification from './AppNotification.vue';

export default {
  components: {
    AppNotification,
  },
  data() {
    return {
      notificationStore,
    };
  },
  computed: {
    notifications() {
      return this.notificationStore.notifications;
    },
  },
  methods: {
    notify() {
      this.notificationStore.notify('Timeout', 'timeout in 8s');
    },
  },
};
</script>
